import { render, staticRenderFns } from "./HomeworkQuestListEdit.vue?vue&type=template&id=2bf80e26&scoped=true&"
import script from "./HomeworkQuestListEdit.vue?vue&type=script&lang=js&"
export * from "./HomeworkQuestListEdit.vue?vue&type=script&lang=js&"
import style0 from "./HomeworkQuestListEdit.vue?vue&type=style&index=0&id=2bf80e26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf80e26",
  null
  
)

export default component.exports